import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import localStorageHelper from '../../../../utils/localStorageHelper';
import Loader from '../../../Loader/Loader';

function HTOAppointment(props) {
    const { bookNowApplicablePrice } = props;
    const [estimatedTime, setEstimatedTime] = useState(0);
    const [moveUserToBookLater, setmoveUserToBookLater] = useState(false);

    useEffect(() => {
        const data = localStorageHelper.getItem('htoAddress');
        setEstimatedTime(data.bookNow ? data.bookNow.estimatedTime : undefined);
    }, []);

    const addCartAndMoveToLater = () => {
        setmoveUserToBookLater(true);
        props.scheduleOrUpdate('bookLater');
    };
    useEffect(() => {
        const { items, totals } = props.cartData;
        if (items.length && moveUserToBookLater) {
            if (!totals.discounts.length) {
                props.applyCoupon(props.couponCode);
            }
            setmoveUserToBookLater(false);
            props.navTo('book-later');
        }
    }, [props.cartData]);

    return (
        <div className="content-container">
            {props.isBookingProcessing && <Loader />}
            {!props.isBookingProcessing && <div className="book-now-wrapper text-center margin-b20 padding-t20 pd-10 mr-b10">
                <h2 className="margin-b20 me-b20 text-uppercase">Please Confirm Booking!</h2>
                <p className="margin-b25 mr-b25 fs14 fsp14">Our optometrist should reach you within <strong>{estimatedTime}</strong> minutes. <br /> <br /> An appointment fee of <strong> Rs. { bookNowApplicablePrice }</strong> will be charged. Pay via cash only.</p>
                <div className="display-flex justify-content-center margin-t10 align-btn">
                    <button onClick={() => props.placeOrder('cod')} className="confirm-btn hto-btn hto-btn__primary margin-r5 mr-r5">
                        <span className="text-color-white text-color_white">CONFIRM BOOKING</span>
                    </button>
                    <button onClick={addCartAndMoveToLater} className="flex-1 hto-btn hto-btn__dark">
                        <span className="text-color-white text-color_white" >SCHEDULE FOR LATER</span>
                    </button>
                </div>
            </div>}
        </div>
    );
}

const mapStateToProps = state => ({
    bookNowApplicablePrice: state.hto.htoConfig.bookNow && state.hto.htoConfig.bookNow.applicablePrice || 0
});

export default connect(mapStateToProps)(HTOAppointment);
